define('viewModels/privileged/devices/SchemaForm',[
    'viewModels/ViewModel',
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'viewModels/widgets/SortableList',
    'services/loggingService',
    'util/propertyUtils',
     //no references required
    'extensions/i18n/knockout.i18n'
], function (ViewModel, ko, _, $, SortableList, loggingService, propertyUtils) {
    'use strict';

    var NEW_ITEM_ENTRY = '.listViewInteraction-new-entry';
    var ADD_ITEM_BUTTON = '.listViewInteraction-action';
    var LIST_ITEM = '.listViewInteraction-entry';

    // NOTE: This is a placeholder binding and not meant to proliferate in the codebase. Please see story UI-399 for
    // the official implementation of the ListView widget specification.
    //
    // FIXME: UI-399
    //
    ko.bindingHandlers.schemaFormListView = {
        init: function (element) {
            $(NEW_ITEM_ENTRY, element).on('keydown.listViewInteraction', function () {
                $(ADD_ITEM_BUTTON, element).trigger('click');
                $(LIST_ITEM, element).last().closest('input')
                    .focus();
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                $(NEW_ITEM_ENTRY).off('.listViewInteraction');
            });
        }
    };

    var getNamespace = function(namespaces) {

        // if array, use the first item, else 'config'
        if(_.isArray(namespaces)) {
            return _.first(namespaces) || 'config';
        }

        // if not, just use the namespace or 'config' if it's not undefined
        return namespaces || 'config';
    };

    /**
     * A ViewModel for an unrecognized schema property.
     */
    var FormControl = ViewModel.extend(function (namespaces, propertyKey, property) {
        var self = this;
        self.type = 'FormControl';

        // get the first (default) namespace that is sent in and use that for the property key
        // it's supposed to be the more specific one namespace for that view
        var namespace = getNamespace(namespaces);
        self.id = namespace.replace(/\./g, '-') + '-' + propertyKey;
        var renderedString = null;

        //check to see if the namespace is a station instance
        //in the form of 'stationTemplateAdvanced.{stationType}_{#instanceNumber}
        var stationInstanceArray =  namespace.split('_');
        if(stationInstanceArray[0])
        {
            var stationKey = stationInstanceArray[0] + '.' + propertyKey;
            //look for localized string that have the form of stationTemplateAdvanced.{stationType}.{property}
            if (ko.i18n.keyExists (stationKey)) {
                renderedString = ko.i18n.renderString(stationKey);
            }
            //if not found, look for localized general station messages in the form stationTemplateAdvanced.{propertyName}
            if (!renderedString)
            {
                stationInstanceArray = namespace.split('.');
                var arrayLength = stationInstanceArray.length;
                if (arrayLength <= 2) {
                    renderedString = ko.i18n.renderString(stationInstanceArray[0] + '.' + propertyKey);
                }
                // if string is in a separate component it will be in form of telephonyAdmin.stationTemplateAdvanced.{propertyName}
                if (arrayLength > 2) {
                    renderedString = ko.i18n.renderString(stationInstanceArray[0] + '.' + stationInstanceArray[1] + '.' + propertyKey);
                }
            }
        }
        else
        {
            renderedString = ko.i18n.renderString(namespace + '.' + propertyKey);
        }

        if (renderedString) {
            self.label = renderedString;
        }
        else if (property.title) {
            self.label = property.title;
            loggingService.warn("Unlocalized label value: " + self.label);
        }
        else {
            self.label = propertyKey;
            loggingService.warn("Unlocalized label value: " + self.label);
        }
    });

    /**
     * A ViewModel for a group of related controls. These can be nested indefinitely.
     */
    var ControlGroup = FormControl.extend(function () {
        var self = this;
        self.type = 'ControlGroup';
        self.viewModels = [];
    }, true);

    /**
     * A ViewModel for a single string input value.
     */
    var TextInput = FormControl.extend(function (namespace, propertyKey, property, valueAccessor) {
        var self = this;
        self.type = 'TextInput';
        self.value = valueAccessor;
        self.value.isModified(false);

        // Need this since Knockout is changing numeric values to strings
        self.data = self.computed({
            read: valueAccessor,
            write: function(newValue) {
                if (property.type === 'integer') {
                    var parsedValue = parseInt(newValue, 10);
                    valueAccessor(isNaN(parsedValue) ? newValue : parsedValue);
                } else {
                    valueAccessor(newValue);
                }
            }
        });
    }, true);

    /**
     * A ViewModel for a single string input value.
     */
    var OptionsMenu = FormControl.extend(function (namespaces, propertyKey, property, valueAccessor) {
        var self = this;
        self.type = 'OptionsMenu';
        self.value = valueAccessor;
        self.options = valueAccessor.schema.enum;
        var namespace = getNamespace(namespaces);
        self.optionsObj = _.sortBy(propertyUtils.createOptionsObject(namespace, propertyKey, self.options),'name');

        self.value.isModified(false);
    }, true);

    /**
     * A ViewModel for a single boolean input value.
     */
    var BooleanInput = FormControl.extend(function (namespace, propertyKey, property, valueAccessor) {
        var self = this;
        self.type = 'BooleanInput';
        self.value = ko.computed({
            read: function () {
                return Boolean(valueAccessor());
            },
            write: function (data) {
                valueAccessor(Boolean(data));
            }
        });
        self.validator = valueAccessor;
    }, true);

    /**
     * A ViewModel for a control allowing a user to enter a list of 0+ free form string values.
     */
    var UserDefinedListOfStrings = FormControl.extend(function (namespace, propertyKey, property, valueAccessor) {

        var self = this;
        var itemId = 1;
        var addItem = function (value) {
            var itemViewModel = {
                value: ko.observable(value),
                id: namespace + '-' + propertyKey + '-entry' + itemId,
                srText: ko.i18n.renderString('schemaForm.listRowLabel', { listLabel: self.label, index: itemId })
            };
            if (valueAccessor.schema.itemValidationOptions) {
                itemViewModel.value.extend(valueAccessor.schema.itemValidationOptions);
            }
            itemViewModel.value.subscribe(function () {
                self.elements.valueHasMutated();
            });
            self.elements.push(itemViewModel);
            ++itemId;
        };

        self.type = 'UserDefinedListOfStrings';
        self.elements = ko.observableArray();
        self.nextValue = ko.observable();

        /**
         * Returns true if there is 1 or more item in the list.
         */
        self.hasElements = ko.computed(function () {
            return self.elements().length > 0;
        });

        /**
         * Add a user defined item into the array.
         */
        self.addItem = function () {
            addItem(self.nextValue());
            self.nextValue('');
        };

        /**
         * Remove a user defined item from the array.
         */
        self.removeItem = function (value) {
            var index = _.findIndex(self.elements(), function (element) {
                return ko.unwrap(element) === value;
            });
            if (index > -1) {
                self.elements.splice(index, 1);
            }
        };

        /**
         * Sync the widget elements with the data model property.
         */
        self.elements.subscribe(function (newElements) {
            valueAccessor(_.map(newElements, function (itemViewModel) {
                return itemViewModel.value();
            }));
        });

        self.validator = valueAccessor;

        // FIXME: Remove the need for peek() here, by removing reckless computeds from modules higher in the stack.
        // Modules: PhoneInstanceEditor, PhoneTemplateEditor, APhoneEditor,BaseTemplatEditor, BaseInstanceEditor
        //
        _.each(valueAccessor.peek(), function (element) {
            addItem(element);
        });
    }, true);

    /**
     * A VieWModel for allowing a user to select 0+ values from a list of system defined values.
     */
    var SystemDefinedListOfStrings = FormControl.extend(function (namespace, propertyKey, property, valueAccessor) {
        var self = this;

        self.type = 'SystemDefinedListOfStrings';

        self.viewModel = self.subView(SortableList,
            property.items.enum,
            valueAccessor
        );

        self.validator = valueAccessor;

    }, true);

    // Recursively processes the SchemaModel producing a ViewModel for each property.
    var buildFormControlViewModelsRecursive = function (namespace, schema, model, viewModels, parentKey) {
        _.each(schema.properties, function (property, propertyKey) {
            if (model[propertyKey]) {

                var fullKey = propertyKey;
                if (parentKey) {
                    fullKey = parentKey + "." + propertyKey;
                }

                // Control Group
                if (property.type === 'object') {
                    var controlGroup = new ControlGroup(namespace, fullKey, property);
                    viewModels.push(controlGroup);
                    buildFormControlViewModelsRecursive(namespace, property, model[propertyKey](), controlGroup.viewModels, fullKey);
                }
                else {

                    // A String
                    if (property.type === 'string') {

                        // Options Menu
                        if (property.enum) {
                            viewModels.unshift(new OptionsMenu(namespace, fullKey, property, model[propertyKey]));
                        }

                        // String Input
                        else {
                            viewModels.unshift(new TextInput(namespace, fullKey, property, model[propertyKey]));
                        }
                    }

                    // Numeric Input
                    else if (property.type === 'number' ||
                        property.type === 'integer') {
                        viewModels.unshift(new TextInput(namespace, fullKey, property, model[propertyKey]));
                    }

                    // Boolean Input
                    else if (property.type === 'boolean') {
                        viewModels.unshift(new BooleanInput(namespace, fullKey, property, model[propertyKey]));
                    }

                    else if (property.type === 'array' &&
                        property.items &&
                        property.items.type === 'string') {

                        // System Defined List of Strings
                        if (property.items.enum) {
                            viewModels.push(new SystemDefinedListOfStrings(namespace, fullKey, property, model[propertyKey]));
                        }

                        // User Defined List of Strings
                        else {
                            viewModels.push(new UserDefinedListOfStrings(namespace, fullKey, property, model[propertyKey]));
                        }
                    }

                    else {
                        viewModels.unshift(new FormControl(namespace, fullKey, property));
                    }
                }
            }
        });
    };

    /**
     * The SchemaForm constructor.
     */
    var SchemaForm = ViewModel.extend(function (namespace, model, schema) {
        var self = this;

        // Handle constructor errors.
        if (namespace === undefined) {
            throw 'A SchemaForm requires a unique namespace to function.';
        }
        if (model === undefined) {
            throw 'A SchemaForm requires a SchemaModel';
        }

        self.allControls = [];
        self.groupControls = [];
        self.simpleControls = [];

        self.basicSettings = ko.observableArray([]);
        self.advancedSettings = ko.observableArray([]);

        self.initSettingsControl = function () {

            if (schema) {
                buildFormControlViewModelsRecursive(namespace, schema, model, self.allControls);
            }

            self.groupControls = _.filter(self.allControls,function(item){
                return item.type === 'ControlGroup';
            });

            self.simpleControls = _.filter(self.allControls,function(item){
                return item.type !== 'ControlGroup';
            });
        };
        /**
         * The toggle state of this form.
         */
        self.isVisible = ko.observable(false);

        /**
         * Toggle the visible state of the form.
         */
        self.toggleVisibility = function () {
            self.isVisible(!self.isVisible());
        };

        /**
         * The label for the show\hide button for this form.
         */
        self.toggleButtonLabel = ko.computed(function () {
            if (self.isVisible()) {
                return 'schemaForm.hide';
            }
            else {
                return 'schemaForm.show';
            }
        });

        self.initSettingsControl();

        ko.validation.group(self.allControls, { deep: true,live:true });

        ko.validation.group(self.simpleControls, { deep: true,live:true });

        _.each(self.groupControls, function (item) {
            ko.validation.group(item, { deep: true,live:true });
        });
    });

    return SchemaForm;
});

